import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/milestones')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/milestone' })
  },
})
